import Vue from "vue";
export const MensajesDeCarga = new Vue();
export const MensajesDeError = new Vue();
export const MensajesDeRespuesta = new Vue();
export const ModalContacto = new Vue();
export const ModalContactoTP = new Vue();
export const ModalSolicitarSimulacion = new Vue();



// WEBPACK FOOTER //
// ./src/utils/BusesDeEventos.js